import { Component, ElementRef, OnInit, inject, viewChild } from "@angular/core";
import { ListStateService } from "src/app/services/list-state.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { MessageService, ConfirmationService } from "primeng/api";
import { Observable } from "rxjs";

export abstract class AbstractFormComponent<T> implements OnInit {
  readonly fileInput = viewChild<ElementRef>("fileInput");

  abstract pageTitle: string;
  abstract form: FormGroup;
  abstract service: any;
  abstract item$: Observable<T>;
  abstract idField: string;
  abstract formFields: string[];
  abstract initializeForm(): void;
  abstract loadItem(id: string): void;

  private readonly listState = inject(ListStateService);

  error: string;
  uploadError: string;
  imagePath: any;
  currentUser: any;

  constructor(
    protected fb: FormBuilder,
    protected messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected router: Router,
    protected route: ActivatedRoute,
    public path: string
  ) {}

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.loadItem(id);
    }
  }

  listParams(): Params {
    return this.listState.get(this.path);
  }

  navigateAfterSave(): void {
    this.router.navigate(["/" + this.path], { queryParams: this.listParams() });
  }

  onSubmit() {
    const formData = new FormData();

    this.formFields.forEach((field) => {
      const control = this.form.get(field);

      if (!control) {
        console.warn(`Skipping missing form control: ${field}`);
        return;
      }

      const value = control.value;

      if (value === undefined || value === null) {
        formData.append(field, "");
        return;
      }

      if (Array.isArray(value)) {
        formData.append(field, JSON.stringify(value));
      } else {
        formData.append(field, value);
      }
    });

    const idControl = this.form.get(this.idField);
    const id = idControl ? idControl.value : null;

    if (id) {
      this.service.update(formData, id).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Success",
              detail: "Saved successfully",
            });
          }
        },
        (error) => this.showSaveError(error)
      );
    } else {
      this.service.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.navigateAfterSave();
          }
        },
        (error) => this.showSaveError(error)
      );
    }
  }

  protected showSaveError(error: any): void {
    this.error = error;
    this.messageService.add({
      key: "myKey1",
      severity: "error",
      summary: "Errore",
      detail: typeof error === "string" ? error : "Salvataggio non riuscito",
    });
  }
}
